/* eslint-disable react/no-danger */
import { Card } from 'crux';
import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import at from 'lodash/at';
import ScrollToTop from '../ScrollToTop';
import { getCSSVariables } from './utils';
import { sanitizeInnerHtml } from '../utils';
import SessionStorageServices from '../util/sessionStorageServices';

const LoaderWrapper = styled.div`
  ${({ isSignature }) =>
    isSignature &&
    `
    flex: 1;
  `}
  div {
    height: calc(100vh - 340px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: auto;
  }
  img,
  video {
    max-width: 425px;
    margin: 0 auto;
    display: block;
  }
  p {
    margin: 0;
    padding: 50px;
    font-size: 36px;
    ${({ showCustomLoader }) => showCustomLoader && 'font-size: 24px;padding:20px;'};
    font-weight: 500;
    color: ${({ color }) => color};
    text-align: center;
  }
  @media (orientation: landscape) {
    div {
      height: 100%;
    }
  }
  //surface pro 7
  @media only screen and (max-width: 912px) {
    img,
    video {
      max-width: 60%;
      height: auto;
    }
  }
  //surface duo
  @media only screen and (max-width: 540px) {
    div {
      min-height: 100%;
    }
    img,
    video {
      max-width: 50%;
    }
    p {
      padding: 20px 50px;
      font-size: 25px;
    }
  }
  @media only screen and (min-width: 1200px) and (max-height: 850px) {
    div {
      height: 100%;
    }
  }
  @media only screen and (max-width: 350px) and (max-height: 700px) {
    div {
      height: 100%;
    }
  }
  // galaxy fold
  @media only screen and (max-width: 300px) {
    div {
      min-height: 100%;
    }
    img,
    video {
      max-width: 60%;
      margin-top: 60px;
    }
    p {
      padding: 50px;
      font-size: 20px;
    }
  }
  @media (max-width: 768px) {
    p {
      ${({ showCustomLoader }) => showCustomLoader && 'font-size: 18px;padding:20px;'};
    }
  }
`;
const Loader = (props) => {
  const { theme, message } = props;
  const isSignature = ['E-SIGNATURE', 'SIGNATURE'].includes(theme.pageId?.toUpperCase());
  const showCustomLoader = SessionStorageServices.getLocalValue('show_custom_loader');
  const docusignMessage = get(theme, 'config.theme.global.postDocusignLoadingMessage');
  // const loader = get(theme, 'config.global.loader');
  const loaderWebm = get(theme, 'config.global.loaderWebm');
  const loaderMp4 = get(theme, 'config.global.loaderMp4');
  const loaderTextColor = get(theme, 'config.theme.global.colorScheme');
  const themeConfiguration = get(theme, 'config.theme.components.card.themeConfiguration', {});

  // CSS Variables
  const cssVariables = getCSSVariables(theme);
  const padding = at(cssVariables, ['pageOverride.padding.card', 'global.padding.card']);

  return (
    <ScrollToTop>
      <LoaderWrapper
        showCustomLoader={ showCustomLoader }
        name='loader-wrapper'
        color={ loaderTextColor }
        isSignature={ isSignature }
      >
        <Card padding={ padding[0] || padding[1] } themeConfiguration={ themeConfiguration }>
          {/* <img src={ loader } alt='Page Loading' /> */}
          <video autoPlay loop muted playsInline preload='auto'>
            <source src={ loaderWebm } type='video/webm' />
            <source src={ loaderMp4 } type='video/mp4' />
          </video>
          <p>
            <span
              dangerouslySetInnerHTML={ {
                // nosemgrep: typescript.react.security.audit.react-dangerouslysetinnerhtml.react-dangerouslysetinnerhtml
                __html: sanitizeInnerHtml(showCustomLoader ? docusignMessage : message),
              } }
            />
          </p>
        </Card>
      </LoaderWrapper>
    </ScrollToTop>
  );
};

const mapStateToProps = (state) => {
  const message = get(state, 'questions.loader.message', 'Just a moment...');
  return {
    message,
  };
};

export default withTheme(connect(mapStateToProps, {})(Loader));
